import styled from 'styled-components'

export const StyledDiv = styled.div`
  border-radius: 10px;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  border-top-left-radius: 24%;
  flex-grow: 1;
`

export const Heading = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
  margin-left: 30px;
`

export const ListItem = styled.div`
  font-size: 12px;
  color: #333;
  text-align: left;
  // margin: 4px 0;
  margin-left: 30px;
`
export const ButtonStyle = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 10px;
  padding: 15px;
  margin-top: auto; /* Pushes the button to the bottom */
`
export const RoundImage = styled.div`
  position: absolute;
  right: 0;
  z-ndex: 1;
  top: -16px;
  width: 100%;
`
export const CardItem = styled.div`
  position: relative;
  background: #e1e1e180;
  border-top-left-radius: 16%;
  height: 425px;
  width: 360px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  flex-direction: column; /* Stack children vertically */
  display: flex;
  // height: 100%; /* Ensure it takes full height */
  min-height: 425px; /* Ensures the card has a minimum height */
`
